module.exports = __webpack_public_path__ + "static/media/standartWindow.c2463d97.jpeg";